import intl from "react-intl-universal";
import { forwardRef } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { getColorBorder, getMessageForImport } from "../utils";
import ImageAlert from 'images/icn-small-alert.svg';
import ImageError from 'images/icn-small-error.svg';
import ImageSuccess from 'images/icn-small-success.svg';
import { Step3Props } from "../types";

const ColWithRef = forwardRef<HTMLDivElement, any>(({ xs, md, lg, className, ...props }, ref) => (
  <Col {...props} ref={ref} xs={xs} md={md} lg={lg} className={className} />
));

const RowWithRef = forwardRef<HTMLDivElement, any>(({ className, ...props }, ref) => (
  <Row {...props} ref={ref} className={className} />
));

const Step3: React.FC<Step3Props> = ({ contextModal, showResultList, nothingImported, importedWithSuccess, resultList }: Step3Props) => {
  const getImage = (type: number) => {
    if (type === 0) {
      return ImageError;
    } else if (type === 1) {
      return ImageAlert;
    } else {
      return ImageSuccess;
    }
  };

  return (
    <div className="content">
      {!showResultList && nothingImported && (
        <span className="title">
          {intl.get(`exportImportModal.${contextModal}.noInformationFound`)}
        </span>
      )}
      {showResultList && (
        <ColWithRef xs={12} md={12} lg={12} className="results-list">
          <RowWithRef className="rowListHeader">
            <span>
              {getMessageForImport(importedWithSuccess, contextModal)}
            </span>
          </RowWithRef>
          <RowWithRef className="messages-list">
            <ColWithRef xs={12} md={12} lg={12} className="messages-items">
              <>
                {resultList.map((value) => (
                  <RowWithRef
                    key={value.Message}
                    className={`rowList ${getColorBorder(value.Type)}`}
                    style={{ borderBottom: "1px dashed #98c1dc" }}
                  >
                    <>
                      <ColWithRef xs={1} md={1} lg={1} className="align-center">
                        <img
                          src={getImage(value.Type)}
                          height="20px"
                          alt="Tipo"
                        />
                      </ColWithRef>
                      <ColWithRef xs={11} md={11} lg={11}>
                        {value.Message}
                      </ColWithRef>
                    </>
                  </RowWithRef>
                ))}
              </>
            </ColWithRef>
          </RowWithRef>
        </ColWithRef>
      )}
    </div>
  );
};

export default Step3;
